import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { useLocalization } from '~/composables/_next/useLocalization';
import { getProductPrice } from '~/utils/ProductPrice';
import { useUser } from '~/composables/_next/useUser';
import { useGetTranslations } from '@/composables/useGetTranslations';
import { klaviyoClientPushEvent } from '~/helpers/tracking/klaviyo';
import { gtmValue } from '~/helpers/gtm';
import { getProductAttrsStringForQueryParams } from '~/helpers/productCardMethods';
import useRightPath from '~/composables/useRightPath';
import { isDiscontinued } from '~/composables/useProduct/useProductAvailability';
import useAddToCart from '~/composables/useAddToCart';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useCart } from '~/composables/useCart';
import { ProductKeys } from '~/types/ProductEnums';
import { BUNDLE_LABEL_ATTR_KEY, BUNDLE_LABEL_DEFAULT_LOCALE, BUNDLE_PRODUCTS_ATTR_KEY } from '~/constants/productsConstants';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
export default defineComponent({
  name: 'BundleProductCard',
  components: {
    AzImg: AzImg,
    AzIcon: AzIcon,
    AzButton: AzButton,
    PriceDisplay: PriceDisplay,
    NuxtLinkCustom: NuxtLinkCustom
  },
  props: {
    product: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props, _ref) {
    var _props$product, _user$value;
    var emit = _ref.emit;
    var _useLocalization = useLocalization(),
      currency = _useLocalization.currency;
    var _useDynamicYield = useDynamicYield(),
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent,
      formatDYprice = _useDynamicYield.formatDYprice;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useUser = useUser(),
      user = _useUser.user,
      isAuthenticated = _useUser.isAuthenticated;
    var route = useRoute();
    var _getProductPrice = getProductPrice(props.product),
      regularPrice = _getProductPrice.regular,
      specialPrice = _getProductPrice.special;
    var price = computed(function () {
      return getProductPrice(props.product);
    });
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var _useLocalization2 = useLocalization(),
      locale = _useLocalization2.locale;
    var _useAddToCart = useAddToCart(),
      normalizeVariants = _useAddToCart.normalizeVariants;
    var _useMobileObserver = useMobileObserver(),
      isMobileView = _useMobileObserver.isMobile;
    var _useCart = useCart(),
      addItemById = _useCart.addItemById,
      cart = _useCart.cart;
    var productLink = function productLink() {
      var queryString = getProductAttrsStringForQueryParams(props.product);
      var defaultLink = app.localePath(getProductPath(props.product));
      if (!isDiscontinued(props.product)) return defaultLink;
      return defaultLink + queryString;
    };
    var link = productLink();
    var title = ((_props$product = props.product) === null || _props$product === void 0 ? void 0 : _props$product._name) || '';
    var pageUrl = route.fullPath;
    var bundleProperties = computed(function () {
      var _props$product2, _props$product2$attri;
      return (_props$product2 = props.product) === null || _props$product2 === void 0 ? void 0 : (_props$product2$attri = _props$product2.attributesRaw) === null || _props$product2$attri === void 0 ? void 0 : _props$product2$attri.reduce(function (acc, curr) {
        acc[curr.name] = curr.value;
        return acc;
      }, {});
    });
    var bundleLabel = computed(function () {
      var _bundleProperties$val, _labelProperty$label, _labelProperty$label2;
      var labelProperty = (_bundleProperties$val = bundleProperties.value) === null || _bundleProperties$val === void 0 ? void 0 : _bundleProperties$val[BUNDLE_LABEL_ATTR_KEY];
      if (!labelProperty) return '';
      return ((_labelProperty$label = labelProperty.label) === null || _labelProperty$label === void 0 ? void 0 : _labelProperty$label[locale.toLowerCase()]) || (labelProperty === null || labelProperty === void 0 ? void 0 : (_labelProperty$label2 = labelProperty.label) === null || _labelProperty$label2 === void 0 ? void 0 : _labelProperty$label2[BUNDLE_LABEL_DEFAULT_LOCALE]);
    });
    var bundleCapacityUnit = computed(function () {
      var _bundleProperties$val2, _capacityProperty$lab, _capacityProperty$lab2;
      var capacityProperty = (_bundleProperties$val2 = bundleProperties.value) === null || _bundleProperties$val2 === void 0 ? void 0 : _bundleProperties$val2[ProductKeys.capacityUnit];
      if (!capacityProperty) return '';
      return ((_capacityProperty$lab = capacityProperty.label) === null || _capacityProperty$lab === void 0 ? void 0 : _capacityProperty$lab[locale.toLowerCase()]) || (capacityProperty === null || capacityProperty === void 0 ? void 0 : (_capacityProperty$lab2 = capacityProperty.label) === null || _capacityProperty$lab2 === void 0 ? void 0 : _capacityProperty$lab2[BUNDLE_LABEL_DEFAULT_LOCALE]);
    });
    var isInStock = computed(function () {
      var _bundleProperties$val3, _bundleProperties$val4;
      return ((_bundleProperties$val3 = bundleProperties.value) === null || _bundleProperties$val3 === void 0 ? void 0 : (_bundleProperties$val4 = _bundleProperties$val3['is-sellable']) === null || _bundleProperties$val4 === void 0 ? void 0 : _bundleProperties$val4.key) === ProductKeys.inStock;
    });
    var bundleCount = computed(function () {
      var _bundleProperties$val5, _bundleProperties$val6;
      return ((_bundleProperties$val5 = bundleProperties.value) === null || _bundleProperties$val5 === void 0 ? void 0 : (_bundleProperties$val6 = _bundleProperties$val5[BUNDLE_PRODUCTS_ATTR_KEY]) === null || _bundleProperties$val6 === void 0 ? void 0 : _bundleProperties$val6.length) || 0;
    });
    var capacity = computed(function () {
      if (!bundleCount.value && !bundleCapacityUnit.value) return '';
      return " ".concat(bundleCount.value, " ").concat(bundleCapacityUnit.value);
    });
    var customerEmail = isAuthenticated.value ? (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.email : '';
    var onAddToCart = function onAddToCart() {
      var _price$value, _price$value2, _props$product3, _cart$value, _props$product4;
      addItemById({
        product: normalizeVariants([props.product])[0],
        quantity: 1,
        showConfirmation: !isMobileView.value
      });
      trackDynamicYieldEvent({
        name: 'Add to Cart',
        properties: {
          dyType: 'add-to-cart-v1',
          value: formatDYprice(price.regular, price.special),
          currency: 'EUR',
          productId: props.product.sku,
          quantity: 1,
          cart: [{
            productId: props.product.sku,
            quantity: 1,
            itemPrice: formatDYprice(price.value.regular, price.value.special)
          }]
        }
      });
      $trackers.gtm.trackAddToCart({
        title: title,
        sku: props.product.sku,
        priceRegular: (_price$value = price.value) === null || _price$value === void 0 ? void 0 : _price$value.regular,
        priceSpecial: (_price$value2 = price.value) === null || _price$value2 === void 0 ? void 0 : _price$value2.special,
        quantity: 1,
        isMaster: (_props$product3 = props.product) === null || _props$product3 === void 0 ? void 0 : _props$product3._master,
        currency: currency,
        cartId: ((_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.id) || '',
        ctId: (_props$product4 = props.product) === null || _props$product4 === void 0 ? void 0 : _props$product4._id,
        pageUrl: pageUrl
      });
      if (customerEmail) {
        var _price$value3, _price$value4, _props$product5, _props$product5$image, _price$value5, _price$value6, _props$product6, _props$product7, _props$product8;
        var AddedProperties = {
          AddedToCartValue: gtmValue((_price$value3 = price.value) === null || _price$value3 === void 0 ? void 0 : _price$value3.regular, (_price$value4 = price.value) === null || _price$value4 === void 0 ? void 0 : _price$value4.special),
          AddedItemCategories: 'product',
          AddedItemCurrency: currency,
          AddedItemImageURL: (_props$product5 = props.product) === null || _props$product5 === void 0 ? void 0 : (_props$product5$image = _props$product5.images[0]) === null || _props$product5$image === void 0 ? void 0 : _props$product5$image.url,
          AddedItemPrice: (_price$value5 = price.value) === null || _price$value5 === void 0 ? void 0 : _price$value5.regular,
          AddedItemPriceDiscount: ((_price$value6 = price.value) === null || _price$value6 === void 0 ? void 0 : _price$value6.special) || '',
          AddedItemProductID: (_props$product6 = props.product) === null || _props$product6 === void 0 ? void 0 : _props$product6._id,
          AddedItemProductName: (_props$product7 = props.product) === null || _props$product7 === void 0 ? void 0 : _props$product7._name,
          AddedItemProductSKU: (_props$product8 = props.product) === null || _props$product8 === void 0 ? void 0 : _props$product8.sku,
          AddedItemProductUrl: link,
          AddedItemQuantity: 1,
          AddedItemURL: pageUrl
        };
        klaviyoClientPushEvent(customerEmail, locale, AddedProperties, 'Added to cart');
      }
    };
    return {
      regularPrice: regularPrice,
      specialPrice: specialPrice,
      capacity: capacity,
      bundleLabel: bundleLabel,
      onAddToCart: onAddToCart,
      title: title,
      isInStock: isInStock,
      translate: translate,
      link: link,
      price: price
    };
  }
});